import { ReactNode } from "react";
import { cn } from "../lib/utils";
import { Tone, TONE_DOT, TONE_SOFT } from "./tones";

interface Props {
  tone: Tone;
  children: ReactNode;
  /** Leading status dot in the tone's solid color (Smartlead's "● Completed" pills). */
  dot?: boolean;
  size?: "sm" | "md";
  className?: string;
  title?: string;
}

/**
 * Outlined, tinted status pill — the one way to render a status/stage/type
 * label anywhere in the app. Color comes from a semantic `Tone`, so it reads
 * correctly on light and dark surfaces alike.
 */
export default function StatusPill({ tone, children, dot, size = "md", className, title }: Props) {
  return (
    <span
      title={title}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border font-medium whitespace-nowrap",
        size === "sm" ? "px-2 py-px text-[10px]" : "px-2.5 py-0.5 text-[11px]",
        TONE_SOFT[tone],
        className,
      )}
    >
      {dot && <span className={cn("w-1.5 h-1.5 rounded-full shrink-0", TONE_DOT[tone])} />}
      {children}
    </span>
  );
}
